module.exports = __webpack_public_path__ + "static/media/extension.0cc6dbb5.md";